export default __webpack_public_path__ + "static/media/luxFa.2fc9cf42.svg";